module.exports = __webpack_public_path__ + "static/media/js.c53b22b5.png";